@if (fetchedCategories$ | async; as categories) { @if (categories && categories.length) {
<div class="category-list-container my-5" [ngClass]="contentlet().cssClass">
  @if (contentlet().categoryTitle) {
  <h2 class="title">
    {{ contentlet().categoryTitle }}
  </h2>
  }
  <custom-dot-cms-uve-category-tile [categories]="categories" [contentlet]="contentlet()" />
</div>
} }
